// extracted by mini-css-extract-plugin
export default {"root":"receiving-points_root__Nx93_","points":"receiving-points_points__de435","heading":"receiving-points_heading__OSDq8"};